const loginform = {
  grant_type: 'password',
  client_id: 'client-app',
  client_secret: '123456',
  username: '',
  password: '',
  type: 'STORE'
}

function hexToStr (hex) {
  let str = ''
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  }
  return str
}
function xorDecrypt (input, key) {
  let result = ''
  for (let i = 0; i < input.length; i++) {
    result += String.fromCharCode(input.charCodeAt(i) ^ key.charCodeAt(i % key.length))
  }
  const [username, password] = result.split(':')
  console.log('username', username, 'password', password)
  // loginform.username = '18340098267'
  // loginform.password = 'yym123456'
  loginform.username = username
  loginform.password = password
}

export function decrypt (mes) {
  console.log('storestorestorestore', mes)
  xorDecrypt(hexToStr(mes), 'my')
  return loginform
}
